export enum FeedbackStatus {
	NEW = 'NEW',
	IN_PROGRESS = 'IN_PROGRESS',
	DONE = 'DONE',
	REJECTED = 'REJECTED'
}

enum UserIdentifierType {
	EMAIL = 'EMAIL',
	PHONE = 'PHONE'
}

export class FeedbackModel {
	id?: number;
	readonly service: string = 'TakeCargoV10.App';
	status: FeedbackStatus = FeedbackStatus.NEW;
	userIdentifierType: UserIdentifierType = UserIdentifierType.PHONE;

	constructor(
		public sessionId: string,
		public content: string,
		public allowContact: boolean = false,
		public userIdentifier: string, // The users phone number in this case
	) {
	}
}